export function log(context, ...message) {
  context.dispatch('debug/log', message, { root: true });
}

export function notify(context, notification) {
  context.dispatch('debug/notify', notification, { root: true });
}
